<template>
  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="textcard">
      <h2>Why &amp; when to <br>choose premium proxies</h2>
      <br>
      <p>We want you to make the perfect proxy choice, so we have listed a
        few scenarios when ProxyScrape premium could be the ideal fit for you:
      </p>
      <ul>
        <li>You need a lot of fast proxies, at a reasonable price.</li>
        <li>The activities you perform consume a lot of internet traffic.</li>
        <li>Many proxies are required to stay unblocked from your target</li>
        <li>You need datacenter proxies</li>
      </ul>
      There are a lot more scenarios when premium proxies might be a perfect choice for you.
      Please don't hesitate to contact the support.
      <br><br>
      Does this sound like something you need? Take a look at our pricing.<p></p>
      <a class="pricing-btn blue-btn mt-4" href="#pricing">PRICING</a>

    </div>
  </div>
  <div class="col-lg-6 col-md-12 col-xs-12">
    <div class="imagecard">
      <button
        class="lets-play"
        data-video="https://vimeo.com/643946453"
        style=" background: none;
          color: inherit;
          border: none;
          padding: 0;
          font: inherit;
          outline: inherit;"
      >
        <img alt="" src="https://cdn.proxyscrape.com/img/video_pp.png"></button>
      <div id="video-wrap"></div>
    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>

</style>
